import type { GraphQLSupporterAddress } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import type { UserError } from '@sola/shared-utils/errors-user.ts';
import { userErrorBadParam } from '@sola/shared-utils/errors/misc.ts';
import {
  httpPutWithStatus,
  isErrorResponse,
} from '@sola/shared-utils/httpClient.ts';
import type { ErrorResponse } from '@sola/shared-utils/httpClient.ts';

import { MY_API_BASE } from '../constants.ts';

export type AddressUpdateMutationError = UserError | UserError[];

export interface AddressUpdateResponse {
  success: boolean;
  data?: GraphQLSupporterAddress | unknown;
  message?: string;
}

const routeAccountSettings = (supporterId: string) =>
  `${MY_API_BASE}/supporters/${supporterId}/address`;

/**
 * Update a supporter's mailing address.
 */
export const updateSupporterAddress = async ({
  globalId,
  address,
}: {
  globalId: string;
  address: Omit<GraphQLSupporterAddress, 'isUndeliverable'>;
}): Promise<AddressUpdateResponse | AddressUpdateMutationError> => {
  if (!globalId) {
    throw userErrorBadParam('globalId');
  }

  if (!address) {
    throw userErrorBadParam('address');
  }

  const { response, statusCode } = await httpPutWithStatus<
    AddressUpdateResponse | ErrorResponse
  >(routeAccountSettings(globalId), address, { signRequest: true });

  if (statusCode !== 200 || !response || isErrorResponse(response)) {
    throw new Error('Failed to update address');
  }

  return response as AddressUpdateResponse;
};
